import React from 'react';
import withTheme from './withTheme';
import { getColors } from './color-extractor';
import { withRouter } from 'react-router-dom';
import './style/ThemedFocus.scss';

export const INSET_CLASSNAME = 'ThemedFocus__Inset';
export const BORDER_CLASSNAME = 'ThemedFocus__Border';
export const FOCUS_SIBLING = 'ThemedFocus__Sibling';
export const NO_FOCUS = 'ThemedFocus__None';
export const FOCUS_CHILD = 'ThemedFocus__Child';
export const FOCUS_CHILD_DEPTH_2 = 'ThemedFocus__ChildDepth2';
export const FOCUS_CHILD_BORDER = 'ThemedFocus__ChildBorder';
// You probably don't want this unless you really want to override
// an existing shadow and don't find a border or outline sufficient
// e.g. something crazy made out of :after and :before
export const IMPORTANT_CLASSNAME = 'ThemedFocus__Important';

const enabledClass = 'ThemedFocus--Enabled';

class ThemedFocus extends React.Component {
  componentDidMount() {
    this.updateStyles();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.theme !== this.props.theme) {
      this.updateStyles();
    }
  }

  updateStyles() {
    const sheet = document.styleSheets[0];
    const colors = getColors(this.props.theme, 'common.focus.default');
    const color = colors['common.focus.default'];
    const w = '3px';

    const notClasses = [
      IMPORTANT_CLASSNAME,
      INSET_CLASSNAME,
      BORDER_CLASSNAME,
      NO_FOCUS,
    ].map(c => `.${c}`);
    // HACK! We want to preserve vstui focus styles even when our global focus style stuff is enabled.
    // It's not the end of the world if these change out from under us; the focus will just look different
    const vstuiPrefixes = [
      'Button__button',
      'TextField__InputControl',
      'TableHeaderCell__sort',
    ].map(c => `[class*=${c}]`);

    const nots = notClasses
      .concat(vstuiPrefixes)
      .map(item => `:not(${item})`)
      .join('');

    sheet.insertRule(
      `.${enabledClass} *${nots}:focus { box-shadow: 0 0 0 ${w} ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} .${IMPORTANT_CLASSNAME}:focus { box-shadow: 0 0 0 ${w} ${color} !important; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} .${INSET_CLASSNAME}:focus { box-shadow: inset 0 0 0 ${w} ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} .${BORDER_CLASSNAME}:focus { border: ${w} solid ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} *:focus ~ .${FOCUS_SIBLING} { box-shadow: 0 0 0 ${w} ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} *:focus > .${FOCUS_CHILD} { box-shadow: 0 0 0 ${w} ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} *:focus > .${FOCUS_CHILD_BORDER} { border: ${w} solid ${color}; }`,
      0
    );
    sheet.insertRule(
      `.${enabledClass} *:focus > * > .${FOCUS_CHILD_DEPTH_2} { box-shadow: 0 0 0 ${w} ${color}; }`,
      0
    );
  }

  render() {
    const classes = ['ThemedFocus', 'ThemedFocus--Enabled'];
    return <div className={classes.join(' ')}>{this.props.children}</div>;
  }
}

export default withRouter(withTheme(ThemedFocus));
